import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import Current from 'frontend/lib/current'
import ActionModal from 'frontend/components/action-modal'

export default class PromoCodeErrorModal extends Component {
  renderBody () {
    return (
      <div>
        <div className="icon">&nbsp;</div>
        <h3>OOPS</h3>
        <p>{this.props.errors.join(', ')}</p>
      </div>
    )
  }

  handleGoToSchedule () {
    window.location = '/' + Current.cityId + '/schedule'
    this.props.onClose()
  }

  render () {
    return (
      <ActionModal
        body={this.renderBody()}
        className="slot_action_modal proceed_with_room_modal"
        leftButtonLabel="Schedule"
        onLeftClick={this.handleGoToSchedule.bind(this)}
        rightButtonLabel="Continue without discount"
        onRightClick={this.props.onRemovePromoCode}
        onClose={this.props.onClose}
        showCloseButton={false}
      />
    )
  }
}

PromoCodeErrorModal.propTypes = {
  errors: PropTypes.array.isRequired,
  onRemovePromoCode: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}
